var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueDraggableResizable',{attrs:{"resizeable":false,"aspect-ratio":false},on:{"dragstop":_vm.onDragstop}},[_c('div',{on:{"pointerdown":_vm.startTimer,"pointerup":_vm.triggerButton}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }